var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-input',{staticClass:"tech-map-input",attrs:{"filled":"","value":_vm.value,"placeholder":_vm.value || '-',"label-slot":false},on:{"input":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }